import { Injectable } from '@angular/core';

@Injectable()
export class LocalstorageService {

  public static retrieve(key: string) {
    const storedItem: string = localStorage.getItem(key);
    if (!storedItem) {
      return null;
    }
    return JSON.parse(storedItem);
  }

  public static store(key: string, content: Object) {
    localStorage.setItem(key, JSON.stringify(content));
  }

  public static remove(key: string) {
    localStorage.removeItem(key);
  }

}
